/** Reading the statuses the notifications stream reports for cameras and servers. */

const ONLINE_STATUSES = ['online', 'recording'];

/**
 * Whether a camera or server status means it is reachable. `status` arrives off the
 * notification union, where a passthrough frame types every field `unknown`.
 */
export function isOnlineStatus(status: unknown): boolean {
    const normalizedText = String(status ?? '').toLowerCase();
    return ONLINE_STATUSES.includes(normalizedText);
}

/**
 * Whether the camera refused the credentials it holds. Its server tries it again only when they
 * change, or when an administrator asks it to.
 */
export function isUnauthorizedStatus(status: unknown): boolean {
    return String(status ?? '').toLowerCase() === 'unauthorized';
}
